module.exports = __webpack_public_path__ + "static/media/closeIcon.c29e18d1.svg";